import { DimensionDTO } from "./dimension.model";
import { UnitDTO } from "./unit.model";

export class PackageDTO {
    isIndividual: boolean;
    weight: UnitDTO;
    dimensions: DimensionDTO;

    constructor(
        isIndividual: boolean = false,
        weight: UnitDTO = new UnitDTO(),
        dimensions: DimensionDTO =new DimensionDTO(),
    ) {
        this.isIndividual = isIndividual;
        this.weight = weight;
        this.dimensions = dimensions;
    }

    public static copy(destination: PackageDTO, source: PackageDTO) : PackageDTO {
        if (destination.isIndividual != source.isIndividual) destination.isIndividual = source.isIndividual;
        destination.weight = UnitDTO.copy(destination.weight, source.weight);
        destination.dimensions = DimensionDTO.copy(destination.dimensions, source.dimensions);

        return destination;
    }
}